/* heading.tsx generated by @compiled/babel-plugin v0.37.1 */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1w901yd3._1w901yd3%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1w9015cr._1w9015cr%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1w90i7uo._1w90i7uo%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1yd3%7Bcolor%3Avar(--ds-text-warning-inverse%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz15cr%7Bcolor%3Avar(--ds-text-inverse%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syazi7uo%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fqoxi4vh._fqoxi4vh%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fqox1qyo._fqox1qyo%7Bfont%3Avar(--ds-font-heading-xsmall%2Cnormal%20653%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fqox1e3o._fqox1e3o%7Bfont%3Avar(--ds-font-heading-small%2Cnormal%20653%201pc%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fqox1af2._fqox1af2%7Bfont%3Avar(--ds-font-heading-medium%2Cnormal%20653%2020px%2F24px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fqox10sd._fqox10sd%7Bfont%3Avar(--ds-font-heading-large%2Cnormal%20653%2024px%2F28px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fqox12ln._fqox12ln%7Bfont%3Avar(--ds-font-heading-xlarge%2Cnormal%20653%2028px%2F2pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fqox1iff._fqox1iff%7Bfont%3Avar(--ds-font-heading-xxlarge%2Cnormal%20653%202pc%2F36px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8i4vh%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c81qyo%7Bfont%3Avar(--ds-font-heading-xsmall%2Cnormal%20653%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c81e3o%7Bfont%3Avar(--ds-font-heading-small%2Cnormal%20653%201pc%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c81af2%7Bfont%3Avar(--ds-font-heading-medium%2Cnormal%20653%2020px%2F24px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c810sd%7Bfont%3Avar(--ds-font-heading-large%2Cnormal%20653%2024px%2F28px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c812ln%7Bfont%3Avar(--ds-font-heading-xlarge%2Cnormal%20653%2028px%2F2pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c81iff%7Bfont%3Avar(--ds-font-heading-xxlarge%2Cnormal%20653%202pc%2F36px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nmk4glyw._nmk4glyw%7Btext-transform%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1i144jg8._1i144jg8%7Bletter-spacing%3Anormal%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._dxsyidpf._dxsyidpf%7Bmargin-block%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1p1dglyw%7Btext-transform%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1dyz4jg8%7Bletter-spacing%3Anormal%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mouidpf%7Bmargin-block%3A0%7D");
import { forwardRef, type ReactNode, type Ref } from 'react';
import { type CompiledStyles } from '@compiled/react';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { UNSAFE_inverseColorMap } from '@atlaskit/primitives';
import { UNSAFE_useSurface } from '@atlaskit/primitives/compiled';
import { useHeading } from './heading-context';
type HeadingColor = 'color.text' | 'color.text.inverse' | 'color.text.warning.inverse';
export type HeadingProps = {
  /**
   * Determines which text styles are applied. A corresponding HTML element is automatically applied from h1 to h6 based on the size.
   * This can be overriden using the `as` prop to allow for more flexibility.
   */
  size: HeadingSize;
  /**
   * Allows the component to be rendered as the specified HTML element, overriding a default element set by the `size` prop.
   */
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
  /**
   * Token representing text color with a built-in fallback value.
   * Will apply inverse text color automatically if placed within a Box with bold background color.
   * Defaults to `color.text`.
   */
  color?: HeadingColor;
  /**
   * The text of the heading.
   */
  children: ReactNode;
  /**
   * Unique identifier for the heading HTML element.
   */
  id?: string;
  /**
   * A `testId` prop is provided for specified elements, which is a unique
   * string that appears as a data attribute `data-testid` in the rendered code,
   * serving as a hook for automated tests.
   */
  testId?: string;
};
const sizeTagMap = ({
  xxlarge: 'h1',
  xlarge: 'h1',
  large: 'h2',
  medium: 'h3',
  small: 'h4',
  xsmall: 'h5',
  xxsmall: 'h6'
} as const);

/**
 * Remove with `platform-dst-heading-specificity` fg cleanup
 */
const styles = {
  reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};

/**
 * Remove with `platform-dst-heading-specificity` fg cleanup
 */
const headingColorStyles = {
  'color.text': "_syazi7uo",
  'color.text.inverse': "_syaz15cr",
  'color.text.warning.inverse': "_syaz1yd3"
};

/**
 * Remove with `platform-dst-heading-specificity` fg cleanup
 */
const headingSizeStyles: {
  readonly xxlarge: CompiledStyles<{
    font: 'var(--ds-font-heading-xxlarge)';
  }>;
  readonly xlarge: CompiledStyles<{
    font: 'var(--ds-font-heading-xlarge)';
  }>;
  readonly large: CompiledStyles<{
    font: 'var(--ds-font-heading-large)';
  }>;
  readonly medium: CompiledStyles<{
    font: 'var(--ds-font-heading-medium)';
  }>;
  readonly small: CompiledStyles<{
    font: 'var(--ds-font-heading-small)';
  }>;
  readonly xsmall: CompiledStyles<{
    font: 'var(--ds-font-heading-xsmall)';
  }>;
  readonly xxsmall: CompiledStyles<{
    font: 'var(--ds-font-heading-xxsmall)';
  }>;
} = {
  xxlarge: "_11c81iff",
  xlarge: "_11c812ln",
  large: "_11c810sd",
  medium: "_11c81af2",
  small: "_11c81e3o",
  xsmall: "_11c81qyo",
  xxsmall: "_11c8i4vh"
};

/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */
const stylesWithSpecificity = {
  reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};

/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */
const headingColorStylesWithSpecificity = {
  'color.text': "_1w90i7uo",
  'color.text.inverse': "_1w9015cr",
  'color.text.warning.inverse': "_1w901yd3"
};

/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */
const headingSizeWithSpecificityStyles: {
  readonly xxlarge: CompiledStyles<{
    '&&': {
      font: 'var(--ds-font-heading-xxlarge)';
    };
  }>;
  readonly xlarge: CompiledStyles<{
    '&&': {
      font: 'var(--ds-font-heading-xlarge)';
    };
  }>;
  readonly large: CompiledStyles<{
    '&&': {
      font: 'var(--ds-font-heading-large)';
    };
  }>;
  readonly medium: CompiledStyles<{
    '&&': {
      font: 'var(--ds-font-heading-medium)';
    };
  }>;
  readonly small: CompiledStyles<{
    '&&': {
      font: 'var(--ds-font-heading-small)';
    };
  }>;
  readonly xsmall: CompiledStyles<{
    '&&': {
      font: 'var(--ds-font-heading-xsmall)';
    };
  }>;
  readonly xxsmall: CompiledStyles<{
    '&&': {
      font: 'var(--ds-font-heading-xxsmall)';
    };
  }>;
} = {
  xxlarge: "_fqox1iff",
  xlarge: "_fqox12ln",
  large: "_fqox10sd",
  medium: "_fqox1af2",
  small: "_fqox1e3o",
  xsmall: "_fqox1qyo",
  xxsmall: "_fqoxi4vh"
};
type HeadingSize = keyof typeof headingSizeWithSpecificityStyles;

/**
 * @codegenEnd
 */

const useColor = (colorProp?: HeadingColor): HeadingColor => {
  const surface = UNSAFE_useSurface();
  if (colorProp) {
    return colorProp;
  }
  if (UNSAFE_inverseColorMap.hasOwnProperty(surface)) {
    return UNSAFE_inverseColorMap[(surface as keyof typeof UNSAFE_inverseColorMap)];
  }
  return 'color.text';
};

/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */
const Heading: React.ForwardRefExoticComponent<React.PropsWithoutRef<HeadingProps> & React.RefAttributes<HTMLHeadingElement>> = forwardRef((props: HeadingProps, ref: Ref<HTMLHeadingElement>) => {
  const {
    children,
    size,
    id,
    testId,
    as,
    color: colorProp
  } = props;
  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production' && as && typeof as !== 'string') {
    throw new Error('`as` prop should be a string.');
  }
  const [hLevel, inferredElement] = useHeading(sizeTagMap[size]);
  const Component = as || inferredElement;
  const needsAriaRole = Component === 'div' && hLevel;
  const color = useColor(colorProp);
  return <Component id={id} ref={ref} data-testid={testId} role={needsAriaRole ? 'heading' : undefined} aria-level={needsAriaRole ? hLevel : undefined} className={ax([styles.reset, fg('platform-dst-heading-specificity') && stylesWithSpecificity.reset, headingSizeStyles[size], fg('platform-dst-heading-specificity') && headingSizeWithSpecificityStyles[size], headingColorStyles[color], fg('platform-dst-heading-specificity') && headingColorStylesWithSpecificity[color]])}>
			{children}
		</Component>;
});
export default Heading;